import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
const DOMPurify = require('dompurify')


@Component({
  selector: 'app-details-offer',
  templateUrl: './details-offer.component.html',
  styleUrls: ['./details-offer.component.css'],
})
export class DetailsOfferComponent {
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  /* number */
  tabulation: number = 10;
  safeDescription!: SafeHtml;
  /* boolean */
  disabledMode: boolean = true;
  /* object */
  jobRequest: any;
  /* string */
  idEsn!: string;
  iduser: any;
  /* formGroup */
  /* unsubscription */
  listconsultant: any;
  toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'],
  ];
  selectedUserId!: string;
  urlimage: string = environment.baseUrlGalery;
  id = this.activatedRoute.snapshot.params['id'];
  state = this.activatedRoute.snapshot.params['state'];
  applyForm: FormGroup = this.createForm();
  /* string */
  url: string = environment.baseUrl + '/api';

  idclientConnected = this.localStorageService.getData('clientConnected');
  nameEsn = this.localStorageService.getData('clientConnectedName');
  skills: any;
  currentUser: any;
  companyRoleId: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private jobofferservice: EsnJobOfferService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private appelofferservice: EsnAppeloffreService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnInit() {
    console.log('bienvenu!!');
    console.log('is state', this.state);
    window.scrollTo(0, 0);
    this.getjobofferById();
    this.getskillsjoboffer();
    this.getlistconsultant();
    this. getcurrentUser();
  }

  /* get job offer details */
  getjobofferById() {
    this.spinner.show();
    this.jobofferservice.getjobofferById(this.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        this.jobRequest = res.data;
        this.updateDescription(this.jobRequest?.description);
      },
      error: () => {},
    });
  }
  updateDescription(description: string) {
    const sanitizedHtml = DOMPurify.sanitize(description);
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }

  /* get skills job offer  */
  getskillsjoboffer() {
    this.jobofferservice.getskillsjoboffre(this.id).subscribe({
      next: (res: any) => {
        this.skills = res.data;
        console.log('skills job offer', this.skills);
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }

  ///////////////postuler///////////////////
  getlistconsultant() {
    console.log('nameEsn', this.nameEsn);
    this.appelofferservice.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
        this.listresponsablesWithDisplayName();
        console.log('list consultant by offre', this.listconsultant);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  listresponsablesWithDisplayName() {
    this.listconsultant.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  // getconsultantid(e: any) {
  //   if (e.target.checked) {
  //     console.log("Selected user id:", this.selectedUserId);
  //   } else {

  //     console.log("Checkbox unchecked");
  //   }
  // }

  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;
      console.log('Selected user id:', this.selectedUserId);

      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    } else {
      // La case est décochée, vous pouvez ajouter un code supplémentaire si nécessaire
      console.log('Checkbox unchecked');
    }
  }

  deselectOtherCheckboxes(currentUserId: string) {
    // Parcourir la liste des consultants et décocher les cases sauf celle qui a été cochée
    // Assurez-vous que this.consultants est la liste de vos consultants
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }
  isDateInFuture(): boolean {
    const availibilityDate = this.applyForm.get('availibility_date')?.value;
    const today = new Date();
    const availibility = new Date(availibilityDate);
    return availibility < today;
  }
  createForm(data?: any) {
    return this.formBuilder.group({
      commercial_argument: [data ? data.commercial_argument : ''],
      tjm_vente: [data ? data.tjm_vente : ''],
      availibility_date: [
        data ? data.availibility_date : '',
        [this.pastDateValidator()],
      ],
      user_id: [data ? data.user_id : null, [Validators.required]],
    });
  }
  pastDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const date = control.value;
      if (date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Ignorer les heures pour comparer uniquement les dates
        const inputDate = new Date(date);

        if (inputDate < today) {
          return { pastDate: true };
        }
      }
      return null;
    };
  }
  postuleroffre() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.selectedUserId,
      job_offer_id: this.id,
    };
    console.log('data', data);
    this.jobofferservice
      .postuleroffre({ ...data, ...this.applyForm.value })
      .subscribe({
        next: (res: any) => {
          console.log('res', res);
          this.toastrService.success(
            'votre candidature a été envoyé avec succès.'
          );
        },
        error: (error) => {
          console.log(error.error.message);
          if (error.error.message === 'candidature already exist.') {
            this.toastrService.error('Candidature existe déjà');
          }
          if (error.error.message === 'the job offer has been deactivated.') {
            this.toastrService.error(
              "La postulation n'est pas autorisée car l'offre d'emploi est désactivé."
            );
          }
        },
      });
  }

  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyRoleId = JSON.parse(this.currentUser).role_user_id;
    console.log('companyRoleId', this.companyRoleId,this.companyRoleId.includes('8'));
  }

  isEsnNotSubscribed(): boolean {
    
    return !this.companyRoleId.includes('8');
  }
  isEsnSubscribed(): boolean {
    return this.companyRoleId.includes('7') ;
  }

  //TOFIX : duplicated
   /**
   * Returns a string list of contract types for tooltip display based on contract type codes.
   * @param contractTypes - An array of contract type codes.
   * @returns A string listing the contract type names.
   */
   getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    return contractTypes.map(type => contractMap[type.toString()] || '').join(', ');
  }
}
